/**
 * @module containers/HazardDisplay
 * @author Charles Blais <charles.blais@canada.ca>
 */

import { useMemo } from 'react';

import { Grid } from 'react-bootstrap';

import { useQuery } from '@apollo/client';

import UserFeedback from '../components/feedback/user-feedback';

import TabsHazard from '../components/tabs-hazard';

import { useLanguageState } from '../contexts/language-state-provider';

import { paramsToGraphQLQuery, paramsToGraphQLVariables } from '../lib/canshm';


type Props = {
  params: HazardInputs
}


/**
 * React container
 * ===============
 */
const HazardDislpay = ({params}: Props) => {
  const [ lang ] = useLanguageState();

  // determine the type of query based on the params
  const query = paramsToGraphQLQuery(params);

  // although the model is not used currently in the response to
  // the GraphSQL query (hard-coded to canSHM6), we add it to the variables
  const variables = useMemo<HazardParameters>(() => paramsToGraphQLVariables(params), [params]);

  const { data, loading, error } = useQuery(query, { variables });

  const isEmpty = !(data && data.canshm);

  return (
    <Grid>
      <UserFeedback
        isLoading={loading}
        isError={Boolean(error)}
        data={(isEmpty)?{}:data.canshm}
      />
      { (!loading && !error && !isEmpty) &&
        <TabsHazard
          variables={variables}
          data={data.canshm}
        />
      }
      <hr/>
      <p><span className="glyphicon glyphicon-arrow-left" aria-hidden="true"></span> {lang.goback}</p>
    </Grid>
  );
}

export default HazardDislpay;
